import { render, staticRenderFns } from "./ClerksModal.vue?vue&type=template&id=136bedf0&scoped=true"
import script from "./ClerksModal.vue?vue&type=script&lang=js"
export * from "./ClerksModal.vue?vue&type=script&lang=js"
import style0 from "./ClerksModal.vue?vue&type=style&index=0&id=136bedf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136bedf0",
  null
  
)

export default component.exports